/**
 * On non-production builds, this will throw an error with the specified message.
 * This is normally used to validate props or prevent engineers from mis-using code.
 * @param {string} message - message that will be in the error.
 */
export const throwErrorForDev = (message) => {
    if (process.env.NODE_ENV?.trim() !== 'production') {
        throw new Error(`DEVELOPMENT ERROR: ${message}`);
    }
};

/**
 * On non-production builds, this will output a warning with the specified message.
 * This is normally used to deprecate components or prevent engineers from mis-using code.
 * @param {string} message - message that will be in the warning.
 */
export const outputDeprecationWarning = (message) => {
    if (process.env.NODE_ENV?.trim() !== 'production') {
        console.warn(`DEPRECATION ALERT: ${message}`);
    }
};
